// extracted by mini-css-extract-plugin
module.exports = {"reset_password_page":"index_reset_password_page__mza6C","success_msg":"index_success_msg__3Td9p"};